export default __webpack_public_path__ + "1be47f7daeea5095680e5decfac753dc.png";